<section class="seat-theater" *ngIf="seats?.length">
  <header class="seat-hero">
    <p class="seat-kicker">The field is set</p>
    <h2 class="seat-title">{{ webinarName || "Tonight's drawing" }}</h2>
    <p class="seat-count">
      <strong>{{ seatCount }}</strong> {{ seatCount === 1 ? 'seat' : 'seats' }} in the draw — watch for yours
    </p>
  </header>

  <div class="seat-hud" *ngIf="tourActive || tourProgress > 0">
    <p class="seat-tour-label">{{ tourLabel }}</p>
    <div class="seat-progress" aria-hidden="true">
      <div class="seat-progress-fill" [style.transform]="'scaleX(' + tourProgress + ')'"></div>
    </div>
  </div>

  <div class="user-seat-grid" #seatsGrid>
    <article
      class="user-seat-card"
      *ngFor="let seat of seats; trackBy: trackBySeat"
      [id]="'seat' + seat.seatNumber"
      [attr.data-seat]="seat.seatNumber"
      [class.is-revealed]="isRevealed(seat.seatNumber)"
      [class.is-focus]="isFocused(seat.seatNumber) && tourActive"
      [class.is-picked]="isPicked(seat.seatNumber)">
      <div class="user-seat-num" aria-hidden="true">{{ seat.seatNumber }}</div>
      <div class="user-seat-info">
        <div class="user-seat-number">Seat #{{ seat.seatNumber }}</div>
        <div class="user-seat-username">{{ seat.userName || 'Anonymous' }}</div>
      </div>
      <span class="user-seat-chip" *ngIf="isPicked(seat.seatNumber)">Drawn</span>
    </article>
  </div>
</section>
